module.exports = __webpack_public_path__ + "img/sv.20aad359.svg";